import React, { memo } from 'react'

import { graphql } from 'gatsby'

import Img from '../components/Img'
import ContactForm from '../components/contactForm'

const ContactFormSection = ({ slice, context }) => {
  const { primary } = slice

  return (
    <section className={`section contact-form-section ${primary?.page}`}>
      {primary?.background_image_one?.gatsbyImageData && (
        <Img
          image={primary.background_image_one.gatsbyImageData}
          alt={primary?.background_image_one?.alt}
          className="background-image background-image-one"
        />
      )}
      <div className="container">
        <div className="contact-form-section--box">
          <h3 className="title">{primary?.title?.text}</h3>
          <ContactForm data={context.contactFormData} />
        </div>
      </div>
      {primary?.background_image_one?.gatsbyImageData && (
        <Img
          image={primary.background_image_one.gatsbyImageData}
          alt={primary?.background_image_one?.alt}
          className="background-image background-image-two"
        />
      )}
    </section>
  )
}

export default memo(ContactFormSection)

export const query = graphql`
  fragment SolutionsDataBodyContact on PrismicSolutionsDataBodyContact {
    id
    primary {
      title {
        text
      }
      background_image_two {
        gatsbyImageData
        alt
      }
      background_image_one {
        alt
        gatsbyImageData
      }
    }
  }
`
